module.exports = __webpack_public_path__ + "static/media/28_tn.03d6810f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/28_tn.jpg
// module id = 516
// module chunks = 0